/**
 * PR 工作台：堆叠条 / 渠道图例共用的品牌色（按渠道 code，小写）。
 * 表格与图例请与此处或 pageConfig 中 colorByCode 保持一致。
 */
export const PR_CHANNEL_BRAND_COLORS: Record<string, string> = {
  facebook: '#0473FF',
  instagram: '#FE8947',
  mixer: '#507794',
  press: '#3C4ACC',
  threads: '#4BD19C',
  tiktok: '#171717',
  twitch: '#8F53D4',
  twitter: '#40C8F1',
  vk: '#00499D',
  youtube: '#FF0000',
  /** games 接口常见 name，与 key 对齐 */
  bilibili: '#FE4B84',
  bluesky: '#72BAFF',
  linkedin: '#0C65C1',
  weibo: '#D52C2B',
  douyin: '#000000',
  wechat: '#07C160',
  discord: '#5865F2',
  reddit: '#FF4500',
};

/** 与 PrMediaTable 中未知渠道条带一致的兜底色板 */
export const PR_CHANNEL_FALLBACK_COLORS: string[] = [
  '#5086F3',
  '#34C759',
  '#FF9500',
  '#AF52DE',
  '#FF3B30',
  '#5AC8FA',
  '#FFD60A',
  '#00C7BE',
  '#FF6482',
  '#A2845E',
];

/**
 * 将 games 接口返回的 channel 名（如 "Facebook" / "TikTok"）规范为与 PR_CHANNEL_BRAND_COLORS 一致的 key
 */
/** 无 games 数据时静态图例顺序（仅 colorByCode 回退方案） */
export const PR_CHANNEL_LEGEND_DEFAULT_ORDER: string[] = [
  'facebook',
  'instagram',
  'twitter',
  'youtube',
  'tiktok',
  'twitch',
  'press',
  'threads',
  'vk',
  'mixer',
];

export function normalizeApiChannelNameToKey(raw: string): string {
  return String(raw || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '');
}

export function getBrandColorByChannelKey(key: string, index: number): string {
  const k = normalizeApiChannelNameToKey(key);
  if (PR_CHANNEL_BRAND_COLORS[k]) {
    return PR_CHANNEL_BRAND_COLORS[k]!;
  }
  return PR_CHANNEL_FALLBACK_COLORS[index % PR_CHANNEL_FALLBACK_COLORS.length]!;
}
